import { graphql } from '@client/graphql/types';

export const TopBannerFragment = graphql(`
  fragment TopBannerItem on TopBanner {
    id
    title
    description
    viewCount
    clickCount
    startTime
    endTime
    isActive
    platforms
    createdAt
    updatedAt

    backgroundColor
  }
`);
